const Filter = ({filters, index}) => {

	return (
		<div className="filter__wrap--dropdown" key={index}>
			<label className="filter" htmlFor={index} tabIndex="0">{filters?.title}</label>
			<select name={filters?.slug} id={index}>
				<option value="">All {filters?.title}s</option>
				{ filters?.filters?.map((filter) => <option value={filter.slug} dangerouslySetInnerHTML={{__html: filter.title}}></option>) }
			</select>
		</div>
	)
}

export default Filter;
